import type { AnamnesisTemplate } from './types';

export const INFANTIL_TEMPLATE: AnamnesisTemplate = {
    id: 'infantil',
    name: 'Anamnese infantil',
    sections: [
        {
            title: 'Identificação',
            questions: [
                'Nome e vínculo de quem responde à entrevista?',
                'Escola e ano escolar?',
                'Com quem a criança mora?',
            ],
        },
        {
            title: 'Queixa principal',
            questions: [
                'Quem percebeu a dificuldade e quando começou?',
                'Em quais contextos o comportamento aparece (casa, escola)?',
                'O que já foi tentado para lidar com isso?',
            ],
        },
        {
            title: 'Gestação e parto',
            questions: [
                'A gestação foi planejada?',
                'Houve intercorrências na gravidez?',
                'Tipo de parto e idade gestacional?',
                'Condições ao nascer (peso, necessidade de UTI, icterícia)?',
            ],
        },
        {
            title: 'Desenvolvimento neuropsicomotor',
            questions: [
                'Com que idade sustentou a cabeça, sentou e andou?',
                'Quando falou as primeiras palavras e frases?',
                'Como foi o controle dos esfíncteres?',
                'Houve alguma preocupação com o desenvolvimento?',
            ],
        },
        {
            title: 'Saúde e histórico médico',
            questions: [
                'Doenças, alergias ou hospitalizações?',
                'Medicações em uso?',
                'Audição e visão já foram avaliadas?',
                'Acompanhamentos anteriores (fono, TO, neuro)?',
            ],
        },
        {
            title: 'Sono e alimentação',
            questions: [
                'Como é a rotina de sono? Dorme sozinha(o)?',
                'Como foi a amamentação e a introdução alimentar?',
                'Há seletividade alimentar?',
            ],
        },
        {
            title: 'História escolar',
            questions: [
                'Como foi a adaptação à escola?',
                'Como é o desempenho e o que a escola relata?',
                'Como é a relação com colegas e professores?',
            ],
        },
        {
            title: 'Comportamento e socialização',
            questions: [
                'Do que gosta de brincar e com quem?',
                'Como reage a frustrações e limites?',
                'Medos, birras ou rituais?',
                'Como é o uso de telas?',
            ],
        },
        {
            title: 'Dinâmica familiar',
            questions: [
                'Quem cuida da criança no dia a dia?',
                'Como são as regras e os combinados em casa?',
                'Eventos marcantes (separação, luto, mudança, nascimento de irmãos)?',
            ],
        },
        {
            title: 'Expectativas dos responsáveis',
            questions: [
                'O que os responsáveis esperam do acompanhamento?',
                'O que considerariam uma melhora?',
            ],
        },
    ],
};
